/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "FARMERONBOARDINGDETAILSREPORT"

export default function FarmerOnboardingView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Supplier Onboarding Details Report'
    });

    const [datevalue, setDateValue] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [farmerDetails, setFarmerDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [cropData, setCropData] = useState({
        farmerName: ''
    });

    const status = [
        {
            value: 1,
            label: 'New'
        },
        {
            value: 2,
            label: 'FCC Approved'
        },
        {
            value: 3,
            label: 'FDC First Approved'
        },
        {
            value: 4,
            label: 'FDC Second Approved'
        },
        {
            value: 5,
            label: 'FCC Rejected'
        },
        {
            value: 6,
            label: 'FDC First Rejected'
        },
        {
            value: 7,
            label: 'FDC Second Rejected'
        },
    ]
    const [formData, setFormData] = useState({
        groupID: '',
        factoryID: '',
        date: null,
        statusID: ''
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        factoryID: ''
    });
    const [statusList, setStatusList] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const farmerOnboardingReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        factoryID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
        statusID: Yup.array()
            .min(1, 'Please select at least one Status')
            .required('Please select at least one Status'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            factoryID: selectedOptions,
            date: formData.date,
            statusID: selectedOptionsStatus
        },

        validationSchema: farmerOnboardingReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    //tobackend
    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            statusID: selectedOptionsStatus.map(x => x).join(',').toString(),
            joinedDate: datevalue == null ? null : new Date(datevalue),
        }
        var res = await services.GetFarmerOnboardingReportDetails(model)
        const formattedRes = res.map(item => {
            const { dob, joingDate, ...rest } = item;
            const dobDate = dob == null ? '-' : dob.substr(0, 10);
            const joingDateFormatted = joingDate.substr(0, 10);
            return { ...rest, dob: dobDate, joingDate: joingDateFormatted };
        });
        setFarmerDetails(formattedRes);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setFarmerDetails([]);
            setDateValue(null);
            setValues({
                ...values,
                factoryID: '',
                statusID: '0'
            })
            setSelectedOptionsStatus([]);
            setSelectedOptions([]);
        } else {
            setSelectedOptionsStatus([]);
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setStatusList(status)
    }, []);

    useEffect(() => {
        setFarmerDetails([]);
    }, [formik.values.groupID, formik.values.factoryID, formik.values.statusID]);

    useEffect(() => {
        setValues({
            ...values,
            statusID: ''
        });
    }, [formik.values.groupID, formik.values.factoryID]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [datevalue]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setFarmerDetails([]);
    }, [selectedOptions, selectedOptionsStatus]);

    useEffect(() => {
        setSelectedOptions([]);
        setSelectedOptionsStatus([]);
    }, [formik.values.groupID]);

    useEffect(() => {
        setSelectedOptionsStatus([]);
    }, [formik.values.factoryID]);

    useEffect(() => {
        setValues({
            ...values,
            factoryID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            statusID: selectedOptionsStatus
        })
    }, [selectedOptionsStatus]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - farmerDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    const handleSelectStatusChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptionsStatus(
                selectedOptionsStatus.length === statusList.length
                    ? []
                    : statusList.map((option) => option.value));
        } else {
            setSelectedOptionsStatus(value);
        }
    };
    const handleClearStatusSelection = () => {
        setSelectedOptionsStatus([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMERONBOARDINGDETAILSREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());

    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(farmerDetails);
        var settings = {
            sheetName: 'Supplier Onboarding Details',
            fileName: 'Supplier Onboarding Details',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Supplier Onboarding Details',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }


    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var festivals = x.farmerFestivalOutputModel.map(item => item.festivalName).filter(name => name !== null).join(', ');
                var vr = {
                    'Registered Collection Centre': x.collectionCenterName,
                    'NIC Number': x.nic,
                    'Supplier Type': x.farmerTypeID == 1 ? 'Farmer' : x.farmerTypeID == 2 ? 'Collector' : x.farmerTypeID == 3 ? 'Farmer & Collector' : '',
                    'Supplier Code- Agrithmics': x.farmerCode,
                    'Supplier Code- Navision': x.navisionNumber == null ? '-' : x.navisionNumber,
                    'Mode of the Operation': x.modeOfOperation == 1 ? "Business" : x.modeOfOperation == 2 ? "Individual" : "-",
                    'Title': x.titleID == 0 ? "" : x.titleID == 1 ? "Mr" : x.titleID == 2 ? "Mrs" : x.titleID == 3 ? "Ms" : x.titleID == 4 ? "Prefer not to mention" : x.titleID == 5 ? "Other" : "-",
                    'Other Title': x.titleID == 5 ? x.otherTitle : "-",
                    'Preferred Name': x.preferedName,
                    'Full Name': x.middleName,
                    'Surname': x.surName,
                    'Date of Birth': x.dob == null ? '-' : x.dob,
                    'Date of Registration': x.joingDate,
                    'Language/s': x.nationality == 1 ? 'Sinhala' : x.nationality == 2 ? 'Tamil' : x.nationality == 3 ? 'Burgher' : '',
                    'Gender': x.gender == 1 ? 'Male' : x.gender == 2 ? 'Female' : '',
                    'Marital Status': x.maritalStatus == 1 ? 'Married' : x.maritalStatus == 2 ? 'Single' : '',
                    'Highest Level of Education': x.education == 1 ? "No Formal Education" : x.education == 2 ? "Grade 1 to 5" : x.education == 3 ? "Upto Grade 8" : x.education == 4 ? "O/Ls" : x.education == 5 ? "A/Ls" : x.education == 6 ? "Diploma" : x.education == 7 ? "Graduate" : x.education == 8 ? "Postgraduate" : x.education == 9 ? "Doctorate" : x.education == 10 ? "Other" : null,
                    'Other Highest Level of Education': x.education == 10 ? x.otherEducation : "-",
                    'Festivals Celebrated': festivals == 0 ? "-" : festivals,
                    'Seasonal Supplier': x.seasonalFarmer == 1 ? 'Yes' : 'No',
                    'Business Name': x.businessName,
                    'Business Registration Number': x.brNumber,
                    'Province': x.provinceName,
                    'District': x.districtName,
                    'City': x.cityName,
                    'DS Division': x.dsDivisionName,
                    'GN Division': x.gnDivisionName,
                    'Address 1': x.address1,
                    'Address 2': x.address2,
                    'Distance to Registered Collection Centre': x.distance,
                    'Primary Contact': x.mobileNumber,
                    'Secondary contact': x.secondaryMobile == 0 ? '' : x.secondaryMobile,
                    'Email Address': x.email,
                    'FCC Approval status': x.farmerStatus == 1 ? "New" : (x.farmerStatus == 2 || x.fccApprovalStatus == 2) ? "FCC Approved" : (x.farmerStatus == 5 || x.fccApprovalStatus == 5) ? "FCC Rejected" : '-',
                    'FCC Approve / Reject User Name': (x.farmerStatus == 1 || x.farmerStatus == 2 || x.farmerStatus == 5 || x.fccApprovalStatus == 2 || x.fccApprovalStatus == 5) ? x.fccApprovalUser : '-',
                    'FDC Approval status': x.farmerStatus == 3 ? "FDC First Approved" : x.farmerStatus == 4 ? "FDC Second Approved" : x.farmerStatus == 6 ? "FDC First Rejected" : x.farmerStatus == 7 ? "FDC Second Rejected" : '-',
                    'FDC Approve / Reject User Name': (x.farmerStatus == 3 || x.farmerStatus == 4 || x.farmerStatus == 6 || x.farmerStatus == 7) ? x.fdcApprovalUser : '-',
                    'Last Updated Date / Time': moment(x.lastUpdatedTime).format('YYYY-MM-DD') + " " +moment(x.lastUpdatedTime).format("hh:mm A")
                }
                res.push(vr);
            });

            res.push({});
            res.push({});

            // var vr = {
            //     'Registered Collection Centre': "Group : " + selectedSearchValues.groupID,
            //     'NIC Number': "Fresh Collection Center : " + selectedSearchValues.factoryID,
            //     'Supplier Type': "Status : " + (selectedSearchValues.statusID == 1 ? 'New' : selectedSearchValues.statusID == 2 ? 'FCC Approved' : selectedSearchValues.statusID == 3 ? 'FDC First Approved' : selectedSearchValues.statusID == 4 ? 'FDC Second Approved' :
            //         selectedSearchValues.statusID == 5 ? 'FCC Rejected' : selectedSearchValues.statusID == 6 ? 'FDC First Rejected' : selectedSearchValues.statusID == 7 ? 'FDC Second Rejected' : 'All Status'),
            // }
            // res.push(vr);
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            factoryID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            statusID: formik.values.statusID
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderSelectedStatusValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = statusList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = statusList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = statusList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Onboarding Details Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.factoryID && errors.factoryID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center"
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.factoryID && errors.factoryID && (
                                            <FormHelperText>{errors.factoryID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}

                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.statusID && errors.statusID)}>
                                        <InputLabel id="multi-select-label">Status *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            fullWidth
                                            multiple
                                            size="small"
                                            value={selectedOptionsStatus}
                                            onChange={handleSelectStatusChange}
                                            label="Fresh Collection Center "
                                            disabled={selectedOptions.length === 0 && formik.values.groupID == '0'}
                                            renderValue={(selected) => renderSelectedStatusValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptionsStatus.length === statusList.length} color="primary" />
                                                All Status
                                            </MenuItem>
                                            {status.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptionsStatus.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.statusID && errors.statusID && (
                                            <FormHelperText>{errors.statusID}</FormHelperText>
                                        )}
                                        {selectedOptionsStatus.length > 0 && (
                                            <IconButton onClick={handleClearStatusSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <div>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error"
                                                onClick={() => clearAll()}
                                            >
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Stack>
                                    </div>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={cropData.farmerName}
                                            placeholder="Search"
                                            onChange={(e) => { handleChange(e) }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {farmerDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                                        <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                            <TableContainer component={Paper} >
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">Fresh Collection Center</TableCell>
                                                            <TableCell align="center">Supplier Code Agrithmics</TableCell>
                                                            <TableCell align="center">Supplier Code -Navision</TableCell>
                                                            <TableCell align="center">Preferred Name</TableCell>
                                                            <TableCell align="center">FCC Approval status</TableCell>
                                                            <TableCell align="center">FCC Approve / Reject User Name</TableCell>
                                                            <TableCell align="center">FDC Approval status</TableCell>
                                                            <TableCell align="center">FDC Approve / Reject User Name</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? farmerDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : farmerDetails
                                                        ).map((row) => (
                                                            <TableRow key={row.farmerCode}>
                                                                <TableCell align="center">
                                                                    {row.collectionCenterName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.farmerCode}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.navisionNumber == null ? '-' : row.navisionNumber}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.preferedName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.farmerStatus == 1 ? <Chip size="small" label="New" style={{ color: 'green' }} />
                                                                        : row.farmerStatus == 2 || (row.fccApprovalStatus == 2) ? <Chip size="small" label="FCC Approved" style={{ color: 'orange' }} />
                                                                            : row.farmerStatus == 5 || row.fccApprovalStatus == 5 ? <Chip size="small" label="FCC Rejected" style={{ color: 'red' }} />
                                                                                : '-'
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {(row.farmerStatus == 1 || row.farmerStatus == 2 || row.farmerStatus == 5 || row.fccApprovalStatus == 2 || row.fccApprovalStatus == 5) ? row.fccApprovalUser : '-'}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.farmerStatus == 3 ? <Chip size="small" label="FDC First Approved" style={{ color: '#B414F9' }} />
                                                                        : row.farmerStatus == 4 ? <Chip size="small" label="FDC Second Approved" style={{ color: 'blue' }} />
                                                                            : row.farmerStatus == 6 ? <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                                                                                : row.farmerStatus == 7 ? <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                                                                                    : '-'
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {(row.farmerStatus == 3 || row.farmerStatus == 4 || row.farmerStatus == 6 || row.farmerStatus == 7) ? row.fdcApprovalUser : '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={6}
                                                                count={farmerDetails.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="Farmer Details" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {farmerDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Supplier Onboarding Details"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    farmerDetails={farmerDetails}
                                    searchData={selectedSearchValues}

                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}